export enum DataHooks {
  Layout = 'daily-agenda-weekly-picker-layout',
  NoAvailableSlots = 'daily-agenda-no-available-slots',
  ShowAllButton = 'daily-agenda-show-all-button',
}
